import { render, staticRenderFns } from "./BalconyBeltMakeupTiles.vue?vue&type=template&id=70458e7c&scoped=true&"
import script from "./BalconyBeltMakeupTiles.vue?vue&type=script&lang=js&"
export * from "./BalconyBeltMakeupTiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70458e7c",
  null
  
)

export default component.exports